// @generated by protoc-gen-connect-es v1.6.1
// @generated from file ai/h2o/mlops/deployer/v1/deployment_service.proto (package ai.h2o.deploy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateDeploymentRequest, CreateDeploymentResponse, DeleteDeploymentRequest, DeleteDeploymentResponse, ListProjectDeploymentsRequest, ListProjectDeploymentsResponse, UpdateModelDeploymentRequest, UpdateModelDeploymentResponse } from "@buf/h2oai_mlops-deployment.bufbuild_es/ai/h2o/mlops/deployer/v1/deployment_service_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service ai.h2o.deploy.DeploymentService
 */
export const DeploymentService = {
  typeName: "ai.h2o.deploy.DeploymentService",
  methods: {
    /**
     * Creates a deployment.
     * Assumed to be mutually exclusive with UpdateModelDeployment for the same deployment target,
     * if concurrent requests for the same target detected then only one requests will be granted access,
     * all other requests need to be retried at later point
     *
     * @generated from rpc ai.h2o.deploy.DeploymentService.CreateDeployment
     */
    createDeployment: {
      name: "CreateDeployment",
      I: CreateDeploymentRequest,
      O: CreateDeploymentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists deployments linked to a specific project.
     *
     * @generated from rpc ai.h2o.deploy.DeploymentService.ListProjectDeployments
     */
    listProjectDeployments: {
      name: "ListProjectDeployments",
      I: ListProjectDeploymentsRequest,
      O: ListProjectDeploymentsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Updates a deployment.
     * Assumed to be mutually exclusive with UpdateModelDeployment and CreateDeployment for the same deployment target,
     * if concurrent requests for the same target detected then only one requests will be granted access,
     * all other requests need to be retried at later point
     *
     * @generated from rpc ai.h2o.deploy.DeploymentService.UpdateModelDeployment
     */
    updateModelDeployment: {
      name: "UpdateModelDeployment",
      I: UpdateModelDeploymentRequest,
      O: UpdateModelDeploymentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Deletes a deployment.
     *
     * @generated from rpc ai.h2o.deploy.DeploymentService.DeleteDeployment
     */
    deleteDeployment: {
      name: "DeleteDeployment",
      I: DeleteDeploymentRequest,
      O: DeleteDeploymentResponse,
      kind: MethodKind.Unary,
    },
  }
};

